<template>
  <div>

    <!-- Exibe URL -->
    <div :class="isInputError('url')" @click="removeError('url')">
      <strong class="title-medium mt-4">{{ $t('views.seller.integrations.config.save.url.title') }}</strong>
      <b-form-group id="fieldset-url" label-for="input-url">
          <b-form-input id="input-url" placeholder="Informe a URL do Smart Notas" class="form-input" v-model="url" :disabled="loading" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
          {{ showError('url') }}
          <template v-if="sugestionRedirect.url">
          <br />
          {{ $t('views.seller.integrations.config.save.url.sugestion_1') }}
          {{ sugestionRedirect.name }}
          {{ $t('views.seller.integrations.config.save.url.sugestion_2') }}
          <a :href="`/integracoes/${sugestionRedirect.url}`" @click.stop>
              {{ $t('views.seller.integrations.config.save.url.sugestion_3') }}
              {{ sugestionRedirect.name }}.
          </a>
          </template>
      </span>
    </div>

    <!-- Exibe a URL webhook -->
    <div>
      <strong class="title-medium mt-4">Copie e adicione o token na configuração da Smart Notas</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
          <b-form-input 
            id="token" 
            placeholder="Token de integração" 
            class="form-input copy" 
            :value="token" 
            :readOnly="true"
            @click="copyValue('token')"
          ></b-form-input>
      </b-form-group>
      <span class="subinfo">Adicione seu token de integração na Smart Notas</span>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";
import TokenService from "@/services/resources/TokenService"; 

export default {
  name: "IntegrationsConfigSmartNotas",
  components: {
    Multiselect
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Smart Notas' })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      url: '',
      token: '',
      loadingSave: false,
    }
  },
  created() {
    this.getToken();
  },
  methods: {
    resetForm() {
      this.url = '';
    },
    setToken(response) {
      this.token = response.api_key;
    },
    getToken() {
      TokenService.build().get('').then(response => {
        this.setToken(response);
      });
    },
    messageSuccess(msg, title) {
      this.$bvToast.toast(msg, {
        variant: "success",
        title: title,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    copyValue(type) {
      const el = document.getElementById(type);
      el.select();
      document.execCommand("copy");
      this.messageSuccess('O Token foi copiado com sucesso', 'Copiado!');
    },
    saveItegration() {
      this.loadingSave = true;

      // Busca para ver se existe config salva
      NoteCenterIntegration.build().search({
        url: '/search/name/SmartNotas',
        name: 'SmartNotas'
      })
      .then(response => {
        if (response.config_integration) {
          this.confirmUpdate();
          return;
        }

        this.updateItegration();
      });
    },
    confirmUpdate() {
      Vue.swal({
        title: 'Integração já existente',
        html: `<p>Para substituir a integração atual, clique no botão abaixo.</p>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.seller.integrations.config.alert.update.ok'),
        cancelButtonText: 'Cancelar',
        customClass: "sweet-container-new",
        confirmButtonClass: "btn btn-primary text-nowrap",
        cancelButtonClass: "btn btn-outline-secondary text-nowrap",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateItegration();
        }
        else {
          this.loadingSave = false;
        }
      });
    },
    updateItegration() {
      NoteCenterIntegration.build().post('', {
        name: 'SmartNotas',
        config_integration: {
          url: this.url
        },
        url: this.url,
        default: false
      }, { suppressErrorNotify: true })
      .then(() => {
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(error => {
        this.mountInputError(error.response.data);
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        })
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
  }
}

</script>